import { motion } from "framer-motion";
import { Zap, BadgeEuro, UserRound } from "lucide-react";
import { AGENCY } from "../../data/content";

const lines = ["Neue Website.", "Mehr Anfragen."];

const lineVariant = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: "0%",
    transition: { duration: 0.7, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

const highlights = [
  { icon: Zap, title: "Online in maximal 24 Stunden", text: "KI-gestützte Umsetzung, verbindlich geplant." },
  { icon: BadgeEuro, title: "949 € einmalig, Festpreis", text: "Komplette Website inklusive Kontaktformular und SEO-Grundlagen." },
  { icon: UserRound, title: "Ein Ansprechpartner", text: "Direkter Draht zu Jannik, kein Callcenter." },
];

export const Hero = () => (
  <section id="top" className="relative min-h-[100svh] flex items-center pt-24 pb-16 px-6 md:px-12 overflow-hidden" data-testid="hero-section">
    <div
      className="absolute inset-0 pointer-events-none"
      style={{
        backgroundImage: "linear-gradient(#1F242C 1px, transparent 1px), linear-gradient(90deg, #1F242C 1px, transparent 1px)",
        backgroundSize: "72px 72px",
        opacity: 0.35,
        maskImage: "radial-gradient(ellipse 90% 70% at 30% 30%, black, transparent)",
        WebkitMaskImage: "radial-gradient(ellipse 90% 70% at 30% 30%, black, transparent)",
      }}
    />
    <div className="relative max-w-7xl mx-auto w-full grid lg:grid-cols-[1.15fr_1fr] gap-14 lg:gap-20 items-center">
      <div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight" data-testid="hero-headline">
          {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-1">
              <motion.span custom={i} variants={lineVariant} initial="hidden" animate="visible" className="block">
                {i === 1 ? <span className="text-[#2E5BFF]">{line}</span> : line}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5, ease: "easeOut" }}
          className="mt-6 text-base md:text-lg text-[#9AA3AF] max-w-xl leading-relaxed"
          data-testid="hero-subline"
        >
          Moderne, verkaufsstarke Websites für Mittelstandsbetriebe, die heute keine oder eine veraltete Seite haben.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.65, ease: "easeOut" }}
          className="mt-10"
        >
          <a href="#kontakt" className="btn-primary px-8 py-4 text-base font-semibold inline-block" data-testid="hero-cta">
            {AGENCY.cta}
          </a>
        </motion.div>
      </div>
      <div className="space-y-4">
        {highlights.map((h, i) => (
          <motion.div
            key={h.title}
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.4 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="bg-[#171B21] border border-[#2A303A] p-6 flex items-start gap-4"
            data-testid={`hero-highlight-${i}`}
          >
            <span className="bg-[#2E5BFF]/12 border border-[#2E5BFF]/40 p-2.5 shrink-0">
              <h.icon className="w-5 h-5 text-[#2E5BFF]" />
            </span>
            <div>
              <p className="font-display text-base md:text-lg font-semibold">{h.title}</p>
              <p className="mt-1 text-sm text-[#9AA3AF] leading-relaxed">{h.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
